import { useRef, useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
// material
import { Box, MenuItem, ListItemIcon, ListItemText } from '@material-ui/core';
// hooks
import useLocales from '../../hooks/useLocales';
// components
import MenuPopover from '../../components/MenuPopover';
import { MIconButton } from '../../components/@material-extend';
// utils
import { handleLanguageChange } from '../../utils/changeLanguage';
import { setUserLanguage } from '../../redux/slices/user';

// ----------------------------------------------------------------------

type LanguagePopoverProps = {
  langCode?: string;
};

export default function LanguagePopover({ langCode }: LanguagePopoverProps) {
  const anchorRef = useRef(null);
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const { allLang, currentLang, onChangeLang } = useLocales();

  useEffect(() => {
    if (langCode) {
      onChangeLang(langCode);
      let resultLang = 'tr';
      if (langCode !== 'tr-TR' && langCode !== 'tr') {
        resultLang = 'en';
      }
      localStorage.setItem('i18nextLng', resultLang);

      onChangeLang(resultLang);
      handleLanguageChange(resultLang);
    }
  }, [langCode]);

  /* // !HATA: Siteye girenlerin ipsini bulma
  /// 1.
  $.getJSON("https://api.ipify.org?format=json", function(data) {
         
        // Setting text of element P with id gfg
        console.log(data.ip);
    }) 

    /// 2.
    getIpCliente(): Observable<string> {
  return this.http
             .get('http://api.ipify.org/?format=jsonp&callback=JSONP_CALLBACK')
             .map((res: Response) => {
               console.log('res ', res);
               console.log('res.json() ', res.text());
               console.log('parseado  stringify ', JSON.stringify(res.text()));
               let ipVar = res.text();
               let num = ipVar.indexOf(":");
               let num2 = ipVar.indexOf("\"});");
               ipVar = ipVar.slice(num+2,num2);

               return ipVar
             }
  );
}

/// 3.
  */
  return (
    <>
      <MIconButton
        ref={anchorRef}
        onClick={() => setOpen(true)}
        sx={{
          padding: 0,
          width: 44,
          height: 44,
          ...(open && { bgcolor: 'action.selected' })
        }}
      >
        <img src={currentLang.icon} alt={currentLang.label} />
      </MIconButton>

      <MenuPopover
        open={open}
        onClose={() => setOpen(false)}
        anchorEl={anchorRef.current}
      >
        <Box sx={{ py: 1 }}>
          {allLang.map((option) => (
            <MenuItem
              key={option.value}
              selected={option.value === currentLang.value}
              onClick={async () => {
                onChangeLang(option.value);
                handleLanguageChange(option.value);

                await dispatch(setUserLanguage(option.value));
                setOpen(false);
                window.location.reload();
              }}
              sx={{ py: 1, px: 2.5 }}
            >
              <ListItemIcon>
                <Box component="img" alt={option.label} src={option.icon} />
              </ListItemIcon>

              <ListItemText primaryTypographyProps={{ variant: 'body2' }}>
                {option.label}
              </ListItemText>
            </MenuItem>
          ))}
        </Box>
      </MenuPopover>
    </>
  );
}
